import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'thermia-react-container';
import { DisplayError } from './completeRegistrationDialog';

interface Props {
  onClick: () => void;
  error?: DisplayError;
}

const CompleteError: FC<Props> = ({ onClick, error }) => {
  const { t } = useTranslation('registrations');

  const handleClick = () => {
    onClick();
  };

  return (
    <>
      <DialogTitle>{t('registrations.general.completeRegistrationError')}</DialogTitle>
      <DialogContent>
        <p>
          {error === 'conflict' && t('registrations.general.completeRegistrationErrorConflict')}
          {error === 'deviceError' && t('registrations.general.completeRegistrationErrorDevice')}
          {error === 'registrationIsAlreadyCompleted' && t('registrations.general.errorRegistrationIsAlreadyCompleted')}
          {error === 'errorRegistrationUnableToCompleteDueItHasBeenDeleted' && t(error)}
          {error === 'other' && t('registrations.general.completeRegistrationErrorOther')}
        </p>
      </DialogContent>
      <DialogActions>
        <Button title={t('registrations.general.ok')} variant={'contained'} onClick={handleClick} />
      </DialogActions>
    </>
  );
};

export default CompleteError;
